module.exports = __webpack_public_path__ + "img/avatar6.41dc5cd0.svg";